module.exports = __webpack_public_path__ + "download2.3f543a5bc75ffb6a0e81.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/assets/img/jpeg/download2.jpg
// module id = ../../../../../src/assets/img/jpeg/download2.jpg
// module chunks = 0